const pluginErrorHandler = {
  apply: (target, context, args) => {
    try {
      typeof target === "function" && target(...args);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  },
};

export default pluginErrorHandler;
